// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ":host{line-height:.5}.tyl-open-icon{color:#757575;color:var(--mdc-theme-icon-color,#757575)}.tyl-open-icon tcw-icon{transition:transform .4s}.tyl-open-icon.tyl-open-icon--open tcw-icon{transform:rotate(180deg)}", ""]);
// Exports
module.exports = exports;
